import React from "react";

import "../../assets/styles/Input.scss";
import {
  PersonalDataType,
  EducationType,
  RewardType,
  WorkExperienceType,
} from "../../types";

export interface InputProps {
  name:
    | keyof PersonalDataType
    | keyof EducationType
    | keyof RewardType
    | keyof WorkExperienceType;
  value: string;
  label: string;
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
  required: boolean;
  isValid: boolean;
  placeholder?: string;
  type?: string;
  id?: string;
}

export interface InputState {}

export const Input = (props: InputProps) => {
  const {
    name,
    value,
    label,
    onChange,
    required,
    isValid,
    placeholder,
    type,
    id,
  } = props;
  return (
    <div className="input-wrapper">
      <label htmlFor={id || name}>{label}</label>
      <div className="input-content">
        <input
          id={id || name}
          type={type || "text"}
          onChange={onChange}
          name={name}
          value={value}
          placeholder={placeholder || ""}
        />
        {(required || value.length > 0) && (
          <div className={isValid ? "mark valid" : "mark invalid"}></div>
        )}
      </div>
    </div>
  );
};

export default Input;
